import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Card, CardHeader, Grid } from '@mui/material';
import { getFileTypeAnalytics } from 'src/services/analytics.service';
import StackedHorizontalBarChart from 'src/sections/@dashboard/app/StackedHorizontalBarChart';

class FileTypeAnalytics extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            by_count: [],
            by_size: [],
        }
    }

    async componentDidMount() {
        let file_type_analytics = await getFileTypeAnalytics();
        
        if (file_type_analytics.error) {
            console.error(file_type_analytics.error);
            return;
        }
        file_type_analytics = file_type_analytics.file_type_analytics;

        let by_count_array = file_type_analytics.by_count || [];
        let by_size_array = file_type_analytics.by_size || [];

        let by_count = [];
        let by_size = [];

        for(let i = 0; i < by_count_array.length; i++) {
            let item = by_count_array[i];
            if (i >= 10) {
                break;
            }
            by_count.push({
                name: item.file_type,
                data: [item.count],
                color: '#FF4560'
            });
        }

        for(let i = 0; i < by_size_array.length; i++) {
            let item = by_size_array[i];
            if (i >= 10) {
                break;
            }
            by_size.push({
                name: item.file_type,
                data: [item.size / 1024 / 1024],
                color: '#FF4560'
            });
        }

        this.setState({
            by_count: by_count,
            by_size: by_size
        });

    }

    render() {

        return (
            <>
                <Card variant='outlined'>
                    <CardHeader title='Files Types' />
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={6}>
                            <StackedHorizontalBarChart
                                series={this.state.by_count}
                                labels={['Count']}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <StackedHorizontalBarChart
                                series={this.state.by_size}
                                labels={['Size']}
                            />
                        </Grid>
                    </Grid>
                </Card>
            </>
        );
    }
}

// Wrap and export
export default function (props) {
    const navigate = useNavigate();
    const params = useParams();

    return <FileTypeAnalytics {...props} navigate={navigate} params={params} />;
}
